/* global __WEB__ */

import moment from 'moment-timezone';

const tickers = {
    morning: [
        'OMXSPI.SSE', // OMX Stockholm PI
        'NI225.OSA', // Nikkei 225
        'I:DAX.GER', // Dax Tyskland
        'I:DJI.DJ', // Dow Jones
        'I:COMP.NAS', // Nasdaq Comp
    ],
    evening: [
        'I:DJI.DJ', // Dow Jones
        'NI225.OSA', // Nikkei 225
        'OMXSPI.SSE', // OMX Stockholm PI
        'I:DAX.GER', // Dax Tyskland
        'I:COMP.NAS', // Nasdaq Comp
    ],
    night: [
        'NI225.OSA', // Nikkei 225
        'OMXSPI.SSE', // OMX Stockholm PI
        'I:DAX.GER', // Dax Tyskland
        'I:DJI.DJ', // Dow Jones
        'I:COMP.NAS', // Nasdaq Comp
    ],
};

export default class ScheduledIndexTickers {
    constructor(dispatch, action) {
        this.dispatch = dispatch;
        this.action = action;

        // Keep a reference to the current period. Compare it to the next possible period to
        // see if it changes.
        this.currentPeriod = null;

        // Insert the current period's tickers. This ensures they are inserted and rendered on the
        // server.
        this.update();

        if (__WEB__) {
            // If we are in the browser, set an interval to run every minute, checks if we
            // enter a new 'period' and change the tickers.
            this.interval = setInterval(() => this.update(), 60 * 1000);
        }
    }

    /**
     * Inserts the tickers for the current period. If the period hasn't changed, nothing is
     * changed.
     */
    update() {
        const period = this.getPeriod();
        if (!this.currentPeriod || this.currentPeriod !== period) {
            this.dispatch(
                this.action(tickers[period])
            );
            this.currentPeriod = period;
        }
    }

    /**
     * Get the period for the current time.
     * Returns a string: 'morning', 'evening' or 'night'.
     */
    getPeriod() {
        const hour = moment().tz('Europe/Oslo').hour();

        if (hour >= 8 && hour < 19) {
            return 'morning';
        } else if (hour >= 0 && hour < 8) {
            return 'night';
        }
        return 'evening';
    }

    stop() {
        if (this.interval) clearInterval(this.interval);
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/service/scheduledindextickers.js
 **/